import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles((theme) => ({
	fullHeight: {
		height: "100%",
	},
	autoMaxHeightItem: {
		flex: 1,
	},
	backgourndImageClass: {
		width: "100%",
		height: "100%",
		position: "absolute",
		objectFit: "cover",
	},
	animInItem: {
		animation: `$animIn 1s ${theme.transitions.easing.easeInOut}`,
	},
	"@keyframes animIn": {
		"0%": {
			opacity: 0.5,
		},
		"100%": {
			opacity: 1,
		},
	},
	animExitItem: {
		animation: `$animInOut 1s ${theme.transitions.easing.easeInOut}`,
		opacity: 0,
	},
	"@keyframes animInOut": {
		"0%": {
			opacity: 1,
		},
		"100%": {
			opacity: 0,
		},
	},
	leftWrapper: {
		backgroundColor: "#464646",
		minWidth: 667,
		position: "relative",
	},
	rightWrapper: {
		flex: 1,
	},
	titleFont: {
		fontSize: "13px !important",
		fontFamily: "Quicksand-SemiBold !important",
	},
	stepperRoot: {
		backgroundColor: "unset !important",
		paddingLeft: 15,
	},
	stepperDotRoot: {
		width: "15px !important",
		height: "15px !important",
		backgroundColor: "#848484",
	},
	dotActiveRoot: {
		backgroundColor: theme.palette.primary.main,
	},
	LoginInputWrapper: {
		margin: "10px 20px",
	},
	loginPwdInputWrapper: {
		paddingTop: 17,
	},
	blackColor: {
		color: "#000000 !important",
		fontFamily: "Quicksand-SemiBold !important",
		fontSize: "16px !important",
		marginBottom: 5,
	},
	InfoWrapper: {
		// height: '125px',
		margin: "15px 15px 0 15px",
		padding: "12px 15px 15px 15px",
		opacity: 0.8,
		display: "flex",
		flexDirection: "column",
	},
	InfoDivider: {
		borderColor: `${theme.palette.primary.main} !important`,
		width: "90%",
	},
	InfoContainer: {
		paddingTop: "11px",
		width: "100%",
		overflow: "auto",
		fontFamily: "Quicksand-SemiBold !important",
		fontSize: 13,
		color: "#000000",
		flex: 1,
	},
	loginIcon: {
		paddingLeft: "9px",
		width: 500,
	},
	iconDivider: {
		height: 5,
		backgroundColor: `${theme.palette.primary.main} !important`,
	},
	welcomeFont: {
		width: 1100,
		// fontSize: 17,
		fontFamily: "Quicksand-SemiBold",
		color: "#000000",
		fontWeight: 600,
		[theme.breakpoints.up("md")]: {
			fontSize: 17,
		},
		[theme.breakpoints.up("lg")]: {
			fontSize: 28,
		},
		[theme.breakpoints.up("xl")]: {
			fontSize: 36,
		},
	},
	loginFont: {
		fontSize: 30,
		fontFamily: "Quicksand-SemiBold",
		color: theme.palette.primary.main,
	},
	loginFormContainer: {
		padding: "20px",
	},
	forgetPwdWrapper: {
		paddingTop: 17,
	},
	inputStyle: {
		height: "30px",
		fontFamily: "Quicksand-SemiBold !important",
		fontSize: "16px !important",
		margin: "0 !important",
	},

	signupWrapper: {
		display: "flex",
	},
	signupInputWrapper: {
		marginTop: "45px !important",
		width: "30%",
	},
	signupInputBox: {
		padding: "30px 29px 40px 30px",
		borderRadius: "30px",
		backgroundColor: "#ffefe1",
	},
	backtoHome: {
		paddingTop: "20px",
	},
	backtoHomeLink: {
		fontSize: 16,
		fontFamily: "Quicksand-SemiBold",
		// color: "#007dc0",
		textDecoration: "none",
	},
	signuBox: {
		padding: "6px",
		borderRadius: "30px",
		backgroundColor: "#ffefe1",
	},
	infoInputBox: {
		width: 1100,
		background: "#fff",
		padding: "10px 20px",
		borderRadius: 4,
		marginTop: "10px",
	},
	InfoLineItem: {
		display: "flex",
		flexDirection: "row",
		alignItems: "flex-start",
		paddingTop: 10,
	},
	InfoLineItemCard: {
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		paddingTop: 1,
	},
	inputInfoStyle: {
		height: "34px",
	},
	inputInfoTitle: {
		color: "#000000 !important",
		fontFamily: "Quicksand-SemiBold !important",
		fontSize: "16px !important",
		minWidth: 125,
		marginRight: 6,
		marginBottom: 0,
		flexShrink: 0,
		paddingTop: 4,
	},
	InfoTitle: {
		width: "200px",
	},
	agreeBox: {
		width: "50%",
		height: "100%",
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "end",
		paddingLeft: "25px",
	},
	// InfoContainer: {
	//     paddingTop: '8px',
	//     height: 'calc(100% - 25px)',
	//     width: '100%',
	//     overflow: 'auto',
	//     '&::-webkit-scrollbar': {
	//         width: 5,
	//         height: 1
	//     },
	//     '&::-webkit-scrollbar-thumb': {
	//         borderRadius: 5,
	//         background: '#D8D8D8'
	//     },
	//     '&::-webkit-scrollbar-track': {
	//         borderRadius: 5,
	//         background: 'unset',
	//     },
	//     scrollbarColor: '#D8D8D8 white',
	//     scrollbarWidth: 'thin',
	// },
	signupDatePicker: {
		width: "67%",
		marginRight: 10,
		"& input": {
			padding: 8,
		},
	},
	signupCheckbox: {
		width: "30%",
		marginBottom: 0,
	},
	agreement: {
		display: "inline-block",
		color: "#2480D9",
	},
	nameTips: {
		display: "flex",
		fontStyle: "italic",
		fontSize: 14,
	},
	nameTipsBox: {
		"&.MuiGrid-item": {
			paddingTop: "4px",
		},
	},
}));
